import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import { Icon } from 'leaflet';
import { osm } from '../../mapTiler/osmProvider.js';
import postionIcon from '../../static/images/map_marker_icon.png'
import 'leaflet/dist/leaflet.css';
import { useState, useRef } from 'react';
import { Link } from 'react-router-dom';


// Questo è il componente Map nella sezione ActivityDetails per gli users
const InactiveLocationMap = ({ coordinates }) => {
    const mapRef = useRef(null);
    const [zoomLevel] = useState(12)

    const markerIcon = new Icon({
        iconUrl: postionIcon,
        iconSize: [32, 64]
    })

    return (
        <div className='w-full lg:w-[800px] border-2 rounded mb-8'>
            <Link to={`https://www.google.com/maps/dir/?api=1&destination=${coordinates.lat},${coordinates.lng}`} target="_blank">
                <MapContainer className='h-48 w-full !cursor-pointer' center={coordinates} zoom={zoomLevel} ref={mapRef}>
                    <TileLayer url={osm.maptiler.url} attribution={osm.maptiler.attribution} />
                    <Marker position={coordinates} icon={markerIcon} />
                </MapContainer>
            </Link>
        </div>
    )
}

export default InactiveLocationMap;